import Navbar from "../../Components/NavBar/index";
import Footer from "../../Components/Footer/index";
import SEO from "../../Components/SEO/index";
import FAQsComponent from "../../Components/FAQs/index";
import Body9 from "../../Components/Home-new/Body9";
import { FaqDataProvider, useFaqData } from "../../database/FaqDataContext";
import { FAQSkeleton, Body9Skeleton } from "../../Components/Skeletons/Skeletons";

const FaqPageContent = () => {
    const { data, isLoading } = useFaqData();

    if (isLoading) {
        return (
            <>
                <FAQSkeleton />
                <Body9Skeleton />
            </>
        );
    }

    return (
        <>
            <div >
                <FAQsComponent preloadedData={data.faqUs} />
            </div>
            <Body9 preloadedData={data.body9} />
        </>
    );
};

// FAQPage structured data, built from the same FAQ list the page shows
const FaqSEO = () => {
    const { data } = useFaqData();
    const faqs = (data?.faqUs?.faqs || []).filter((f) => f.question && f.answer);
    const faqSchema = faqs.length > 0 ? {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((f) => ({
            '@type': 'Question',
            name: f.question,
            acceptedAnswer: { '@type': 'Answer', text: f.answer },
        })),
    } : undefined;
    return <SEO pageName="faq" customStructuredData={faqSchema} />;
};

const FAQ = () => {
    return (
        <FaqDataProvider>
            <FaqSEO />
            <Navbar />
            <FaqPageContent />
            <Footer />
        </FaqDataProvider>
    );
};

export default FAQ;
